import * as React from 'react';
import { AddToCart } from '@grandvisionhq/carts-v2';
import { Button } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import 'classnames';
import '@grandvisionhq/forms';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import '../../../../../types/product.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/elements';
import '@grandvisionhq/inventory';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/lib-utils-html';
import '../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import '@grandvisionhq/icons';
import 'use-onclickoutside';
import '@grandvisionhq/lib-visuals';
import '../../../../../hooks/useCartDiscounts/types.js';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../hooks/use-product-view-history.js';
import '../../../../../slots/context.js';
import { FindAStoreCTA } from '../../../components/CTAs/FindAStoreCTA/FindAStoreCTA.js';
import '@grandvisionhq/content';
import { useSolutionsEcommContext } from '../../context/SolutionsEcommContext.js';
import { SolutionsCTACaption } from './components/SolutionsCTACaption.js';
import { mapSolutionToDraftLineItem } from './map-solution-to-draft-line-item.js';

const SolutionsCTA = ()=>{
    const { getLabel  } = useIntl();
    const { routes , activeVariant , selectedPurchaseType  } = useProductData();
    const { state , actions  } = useSolutionsEcommContext();
    const lineItemDraft = mapSolutionToDraftLineItem({
        sku: activeVariant.sku,
        state,
        purchaseType: selectedPurchaseType
    });
    if (activeVariant.channelAvailability !== 'ONLINE') {
        return /*#__PURE__*/ React.createElement(FindAStoreCTA, {
            href: routes.stores
        });
    }
    if (!state.configurator.isConfiguratorValid || !lineItemDraft) {
        // Dummy button with the "Add to cart" caption which only triggers form validations
        const triggerValidations = ()=>{
            actions.triggerValidationErrors();
        };
        return /*#__PURE__*/ React.createElement(Button, {
            caption: getLabel('products.solutions.addToBasket'),
            onClick: triggerValidations
        });
    }
    return /*#__PURE__*/ React.createElement(AddToCart, {
        caption: /*#__PURE__*/ React.createElement(SolutionsCTACaption, null),
        lineItemDrafts: [
            lineItemDraft
        ]
    });
};

export { SolutionsCTA };
//# sourceMappingURL=SolutionsCTA.js.map
